require('./bootstrap');

var components = './components/';
// Load all custom javascript in new files like the example below
// require(components + 'your-file')


// WEBPACK FOOTER //
// ./resources/assets/js/login/app.js